/**
 * Created by aviranb on 24/09/2017.
 */

export default function ExceptionHandlerDecorator($provide) {
	$provide.decorator('$exceptionHandler', ($delegate, $injector) => {
		return (exception, cause) => {
			$delegate(exception, cause);
			/*$injector
				.get('JFrogNotifications')
				.create({
					error: exception.message//, timeout: 3000
				});*/
		};
	});
}



// WEBPACK FOOTER //
// ./modules/distribution/services/exception.handler.decorator.js